<app-meeting-add
  [typeOnlyKeys] = "typeOnlyKeys"
  (meetingCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
  [dialogRefFront]="true"
></app-meeting-add>
